import { Box, Stack } from "@mui/material";
import LanguageContext from "components/LanguageContext";
import Button from "components/templatesComponents/Button";
import Link from "components/templatesComponents/Link";
import { buttonStyled } from "components/templatesComponents/StyledComponent";
import PropTypes from "prop-types";
import React, { useContext } from "react";
import t from "utils/locales/translation.json";
import Pictogram from "../../templatesComponents/Pictogram";

const WebcallbackMainBlock = (props) => {
  const { title, subtitle = "", pageToReturn = null, icon = "", url = "" } = props;

  const { language } = useContext(LanguageContext);

  let pictogram = null;
  switch (icon) {
    case "calendar":
      pictogram = <Pictogram folder="digital" pictogram="calendar" />;
      break;
    case "calendar-unavailable":
      pictogram = <Box component="img" src={`/${icon}.svg`} alt="" />;
      break;
    default:
      break;
  }

  return (
    <Stack
      sx={{
        px: { xs: 2, lg: 5 },
        py: { xs: 4, lg: 5 },
        border: "1px solid var(--border-default-blue-france)",
        bgcolor: "var(--background-alt-blue-france)",
        "& svg, img": {
          width: 80,
        },
      }}
    >
      {pictogram}
      <h3 className="fr-mb-1w">
        {title}&nbsp;
        {url && (
          <a href={`mailto:${url}`} className="fr-h3 fr-link">
            {url}
          </a>
        )}
      </h3>
      <p className={`fr-text--lg${pageToReturn ? "" : " fr-mb-0"}`}>{subtitle}</p>
      {pageToReturn && (
        <Button iconDSFR="arrow-go-back-line" component={Link} basic page={pageToReturn} sx={buttonStyled}>
          {t[language].webcallback.no_slot_button_label}
        </Button>
      )}
    </Stack>
  );
};

WebcallbackMainBlock.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  pageToReturn: PropTypes.shape(),
  icon: PropTypes.string,
  url: PropTypes.string,
};

export default WebcallbackMainBlock;
